import api from "../api/api";
import { Callback, Livraria } from "../types/general";
import useLivrariaStore from "../zustand/use-livraria-store";

function useLivrariaModel() {

  const {
    livrarias,
    setLivrarias,
    setSelectedLivraria,
    resetState,
    removeLivraria,
    updateLivraria,
  } = useLivrariaStore();

  // Fetch all livrarias with pagination
  const fetchLivrarias = async (page: number = 1) => {
    try {
      const response = await api.get({
        path: "/api/livrarias",
        params: { page },
      }, (data: any) => {
        setLivrarias(data);
      }, (error: any) => {
        console.error("Error fetching livrarias:", error);
      });

      return response;
    } catch (error) {
      console.error("Error fetching livrarias:", error);
      throw error;
    }
  };

  // Create new livraria
  const createLivraria = async (
    data: {
      name: string;
      description: string;
      type: 'SNE' | 'OTHERS';
    },
    callback?: Callback
  ) => {
    try {
      api.post({
        path: "/api/livrarias",
        data: {
          name: data.name,
          description: data.description,
          type: data.type,
        },
      }, (responseData: any) => {
        callback?.response?.(responseData);
        setLivrarias({
          ...livrarias,
          data: [...[responseData], ...livrarias.data]
        });
      }, (error: any) => {
        callback?.error?.(error);
      });
    } catch (error) {
      console.error("Error creating livraria:", error);
      throw error;
    }
  };

  // Update existing livraria
  const updateLivrariaById = async (
    livraria: Livraria,
    callback?: Callback
  ) => {
    try {
      api.put({
        path: "/api/livrarias",
        params: { livraria: livraria.id },
        data: {
          name: livraria.name,
          description: livraria.description,
          type: livraria.type,
        },
      }, (data: any) => {
        callback?.response?.(data);
        updateLivraria(data);
      }, (error: any) => {
        callback?.error?.(error);
      });
    } catch (error) {
      console.error("Error updating livraria:", error);
      throw error;
    }
  };

  // Delete livraria
  const deleteLivrariaById = async (id: number, callback: Callback) => {
    try {
      await api.delete({
        path: "/api/livrarias",
        params: { livraria: id },
      }, (data: any) => {
        callback.response?.(data);
        removeLivraria(id);
      }, (error: any) => {
        callback.error?.(error);
      });
    } catch (error) {
      console.error("Error deleting livraria:", error);
      throw error;
    }
  };

  return {
    fetchLivrarias,
    createLivraria,
    updateLivrariaById,
    deleteLivrariaById,
  };
}

export default useLivrariaModel;
